(function(){
    'use strict';

    angular
    .module('appback')
    .controller('ExternalizadasController', ExternalizadasController)
 
    ExternalizadasController.$inject = ["ExternalizadasService","GenerallabService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function ExternalizadasController(ExternalizadasService,GenerallabService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;
		vm.generalLab = GenerallabService;
		vm.filtros = {};
		vm.code = false;
		vm.buttonEnviarDisabled = false;
        
    	vm.guardar = function(){
			vm.buttonEnviarDisabled = true;
    		ExternalizadasService.guardar(vm.filtros,function(data){
    			vm.code = data.code;
    			vm.msg = data.msg;
    			if(vm.code==10){
    				window.location.reload();
    			}else{
					vm.buttonEnviarDisabled = false;
    			}
	        })
    	}
    }
  
})();